import { ContextFormByIdProvider, IContextFormByIdBeforeMount } from "@ngt/forms";
import { FC, PropsWithChildren } from "react";
import { useParams } from "react-router-dom";
import { FormDefinitions } from "../../api/dtos";

export interface IProjectAgentLocationFormByIdRouteProps extends PropsWithChildren {
    projectAgentLocationId?: number | undefined;

    loadBeforeMount?: boolean | IContextFormByIdBeforeMount;
    validateBeforeMount?: boolean | IContextFormByIdBeforeMount;
}

const ProjectAgentLocationFormByIdRoute: FC<IProjectAgentLocationFormByIdRouteProps> = ({
    projectAgentLocationId,
    loadBeforeMount,
    validateBeforeMount,
    children
}) => {
    const params = useParams();

    const projectAgentLocationIdToUse = (params.projectAgentLocationId ? +params.projectAgentLocationId : undefined) ?? projectAgentLocationId ?? undefined;

    return (
        <ContextFormByIdProvider
            formId={projectAgentLocationIdToUse}
            formDefinitionIdentifier={FormDefinitions.ProjectAgentLocation}

            loadBeforeMount={loadBeforeMount}
            //LoadingComponent={RouteLoading}

            validateBeforeMount={validateBeforeMount}
            //ValidatingComponent={RouteLoading}
        >
            {children}
        </ContextFormByIdProvider>
    );
}

export default ProjectAgentLocationFormByIdRoute;
